'use strict';exports.__esModule = true;var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _manageProperties = require('../../redux/modules/manageProperties');
var _contactUser = require('../../../static/images/contact-user.svg');var _contactUser2 = _interopRequireDefault(_contactUser);
var _ = require('..');
var _Form = require('./Form/Form');var _Form2 = _interopRequireDefault(_Form);
var _UpdatePropertyActivityModal = require('./UpdatePropertyActivityModal.scss');var styles = _interopRequireWildcard(_UpdatePropertyActivityModal);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

UpdatePropertyActivityModal = function (_React$Component) {_inherits(UpdatePropertyActivityModal, _React$Component);function UpdatePropertyActivityModal() {var _temp, _this, _ret;_classCallCheck(this, UpdatePropertyActivityModal);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    state = {
      isLoading: false }, _this.
















    handleSubmitForm = function (values) {var
      userData = _this.props.userData;

      if (!userData) return;var _this$props =






      _this.props,propertiesWithoutContactsIds = _this$props.propertiesWithoutContactsIds,localPropertiesIds = _this$props.localPropertiesIds,foreignPropertiesIds = _this$props.foreignPropertiesIds,onClose = _this$props.onClose;

      _this.setState({ isLoading: true });

      var userHasVirtualNumbers = !!userData.virtual_numbers.length;

      var payload = {
        ids: propertiesWithoutContactsIds,
        primary: {
          phone: values.primary.value,
          realtor_id: values.primary.realtor_id,
          name: values.primary.name,
          from_user_himself: userHasVirtualNumbers ? undefined : true },

        secondary: values.secondary ? {
          phone: values.secondary.value,
          realtor_id: values.secondary.realtor_id,
          name: values.secondary.name } :
        undefined };


      _this.props.updatePropertiesContacts({ data: payload, access_token: userData.access_token }).
      then(function () {return _this.props.updateLocalAndForeignPropertiesActivity(localPropertiesIds, foreignPropertiesIds, true);}).
      finally(function () {
        _this.setState({ isLoading: false });
        onClose();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);}UpdatePropertyActivityModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {if (this.props.isOpen && !prevProps.isOpen) {document.documentElement.style.overflow = 'hidden';}if (!this.props.isOpen && prevProps.isOpen) {document.documentElement.style.overflow = '';}};UpdatePropertyActivityModal.prototype.componentWillUnmount = function componentWillUnmount() {document.documentElement.style.overflow = '';};UpdatePropertyActivityModal.prototype.

  render = function render() {var _props =
    this.props,isOpen = _props.isOpen,onClose = _props.onClose,translate = _props.translate,isRtl = _props.isRtl;var
    isLoading = this.state.isLoading;

    return (
      _react2.default.createElement(_.Modal, { className: styles.modal, isOpen: isOpen, onRequestClose: onClose },
        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('div', { className: styles.iconWrapper },
            _react2.default.createElement('div', { className: styles.userIcon },
              _react2.default.createElement('img', { src: _contactUser2.default, alt: 'User icon' }))),


          _react2.default.createElement('h3', { className: styles.title },
            translate(
            'managePage',
            'propertyToggle',
            'missingContactsModal',
            'title')),


          _react2.default.createElement(_.WarningMessage, null,
            _react2.default.createElement('p', null,
              translate(
              'managePage',
              'propertyToggle',
              'missingContactsModal',
              'alreadyHaveContacts'),

              _react2.default.createElement('span', { className: styles.boldMessage },
                translate(
                'managePage',
                'propertyToggle',
                'missingContactsModal',
                'alreadyHaveContactsBold')))),




          _react2.default.createElement('p', { className: styles.note },
            translate(
            'managePage',
            'propertyToggle',
            'missingContactsModal',
            'note')),


          _react2.default.createElement(_Form2.default, {
            translate: translate,
            isLoading: isLoading,
            onFormSubmit: this.handleSubmitForm,
            isRtl: isRtl }))));




  };return UpdatePropertyActivityModal;}(_react2.default.Component);


UpdatePropertyActivityModal.propTypes = {
  isOpen: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  propertiesWithoutContactsIds: _propTypes2.default.array,
  localPropertiesIds: _propTypes2.default.array,
  foreignPropertiesIds: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  updatePropertiesContacts: _propTypes2.default.func,
  updatePropertyActivity: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  updateLocalAndForeignPropertiesActivity: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
    userData: state.userAuthentication.data };};


var mapDispatchToProps = {
  updatePropertiesContacts: _manageProperties.updatePropertiesContacts,
  updatePropertyActivity: _manageProperties.updatePropertyActivity };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpdatePropertyActivityModal);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/UpdatePropertyActivityModal.js
// module id = 2942
// module chunks = 0